<template>
  <div class="container-row row">
    <div class="container-col">
      <form>
        <div class="logo"></div>
        <br />
        <br />
        <div class="form-group">
          <label for="emailInput">Email</label>
          <input type="email" class="form-control" id="emailInput" v-model="email" />
          <br />
        </div>
        <div class="form-group">
          <label for="passwordInput">Senha</label>
          <input type="password" class="form-control" id="passwordInput" v-model="password" v-on:keyup.enter="login" />
          <br />
          <router-link :to="{ name: 'ResetPasswordEmail' }">Redefinir Senha</router-link>
          <br />
          <b-alert v-show="loginErro" variant="danger" show>Usuário ou senha incorretos</b-alert>
          <b-alert v-show="emptyField" variant="warning" show>Por favor, preencha todos os campos.</b-alert>
          <br />
        </div>
        <div class="form-group">
          <button class="btn btn-dark" type="button" @click="login">Entrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      loginErro: false,
      emptyField: false,
    };
  },
  methods: {
    async login() {
      this.emptyField = false;
      this.loginErro = false;
      
      if (this.email && this.password) {
        try {
          await this.$store.dispatch("auth/login", {
            email: this.email,
            password: this.password,
          });
          setTimeout(() => {
            if (this.$store.state.auth.token) {
            router.push("/admin/Home");
          } else {
            this.loginErro = true;
          }
          }, 1500);
        } catch (error) {
          this.loginErro = true;
        }
      } else {
        this.emptyField = true;
      }
    },
  },
  created() {
    const userTypes = ["admin", "employee", "client"];
    if (this.$store.state.auth.isLogged && userTypes.includes(this.$store.state.auth.role)) {
      router.push("/admin/Home");
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/Login.scss";
</style>
